import React from "react"
import PropTypes from "prop-types"
import { Typography, Flex } from "antd"
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons"
import styles from "../style.module.css"

const { Text } = Typography

export default function StatsRow({ stats }) {
  return (
    <div className={styles.statsRow}>
      {stats.map((stat) => (
        <div key={stat.label} className={styles.statCard}>
          <Text type="secondary" className={styles.statLabel}>{stat.label}</Text>
          <Text strong className={styles.statValue}>{stat.value}</Text>
          <Flex align="center" gap={4} className={styles.statTrend}>
            {stat.trend < 0
              ? <ArrowDownOutlined className={styles.trendDown} />
              : <ArrowUpOutlined className={styles.trendUpIcon} />
            }
            <Text className={`${stat.trend < 0 ? styles.trendDown : styles.trendUpIcon} ${styles.textSm}`}>
              {Math.abs(stat.trend)}%
            </Text>
            <Text type="secondary" className={styles.textSm}>{stat.period}</Text>
          </Flex>
        </div>
      ))}
    </div>
  )
}

StatsRow.propTypes = {
  stats: PropTypes.array.isRequired
}
